import React, { Component } from 'react';
import { BASE_URL } from '../../../constants/Common';

export default class BannerImage extends Component {
  state = {
    src: this.props.src,
  };
  render() {
    return (
      <img
        onError={() => {
          this.setState({ src: require('../../../assets/img/dashboard/silder.jpg') });
        }}
        src={BASE_URL + this.state.src}
        alt="banner"
      />
    );
  }
}
